import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import SchemesDiscountDetail from './components/SchemesDiscountDetails.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageSchemesDiscount',
  components: {
    SchemesDiscountDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;